// Globalny stan aplikacji - CMS
import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface ICmsArticlesFilters {
  page?: number;
  limit?: number;
  search_keyword?: string;
  section_id?: number | null;
}

interface ICmsSlidersFilters {
  page?: number;
  limit?: number;
  search_keyword?: string;
}

// typ cms
interface ICmsSlice {
  // Filtry dla listy artykułów
  articlesFilters?: ICmsArticlesFilters;
  // Filtry dla listy sliderów
  slidersFilters?: ICmsSlidersFilters;
}

// dane inicjalizacyjne
const initialState: ICmsSlice = {
  articlesFilters: undefined,
  slidersFilters: undefined
};

export const cmsSlice = createSlice({
  name: 'cms',
  initialState,
  reducers: {
    setArticlesFilters: (
      state,
      action: PayloadAction<ICmsArticlesFilters>
    ) => {
      state.articlesFilters = action.payload;
    },
    setSlidersFilters: (
      state,
      action: PayloadAction<ICmsSlidersFilters>
    ) => {
      state.slidersFilters = action.payload;
    }
  }
});

export const cmsSliceActions = cmsSlice.actions;

export default cmsSlice.reducer;
